import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString';
import {boundingExtent,createEmpty,extend} from 'ol/extent';
import NodeTypes from './Nodes';

import store from '@/store';
import { generateID } from '../../utils/utils';

// 水文件的json格式
import {water as waterjson,steam as steamjson,draw as drawjson,insulationWater as insulationWaterjson, insulaScheme, insulaMaterial} from "./FileFormat";

export default class Open {
    constructor(map){
        this.map=map;
        // 获取绘图图层
        this.drawSource=store.state.simulation.drawSource;
        // 获取绘图框
        this.$el=map.getTargetElement();
    };
    lines=null; // 管道列表
    /**
     * 加载示例管道信息
     */
    // open(){
    //     getNodes().then(res=>{
    //         if(res.status&&res.status==200){
    //             let content=res.content;
    //             let links=content.links;
    //             this.openInp(links);
    //         }
    //     })
    // }
    /**
     * 读取inp文件，并绘制管道
     * @param {*} links 
     */
    openInp(links){
        // 图层源
        let source=this.drawSource;
        /**
         * 根据源码查看，计算坐标点的逻辑如下,w为页面宽，h为页面高，NODE_DIAM = 2
         * (1) 将所有的点求取外包矩形;
         * (2) 根据页面的宽w,高:h,根据公式：factor =(bounds.width / bounds.height) < (((double) w) / h) ? h / bounds.height : w / bounds.width，求factor;
         * (3) 求所有点中的最小x坐标dx,最小y坐标dy;
         * (4) dwidth= Math.abs(最大的x坐标-最小的x坐标),dheight=Math.abs(最大的y坐标-最小的x坐标);
         * (5) factor *= .9d;
         * (6) dx += dwidth * .5d - w * 0.5 / factor;dy += dheight * .5d - h * 0.5 / factor;
         * (7) 构建坐标点x=(int)(position.getX() - dx) * factor,y=(int)(-position.getY() - dy) * factor
         * (8) 绘制图像：x=(int)(point.getX() - NODE_DIAM / 2), y=(int)(point.getY() - NODE_DIAM / 2)
         */
        let minX=Number.MAX_VALUE;
        let minY=Number.MAX_VALUE;
        let maxX=Number.MIN_VALUE;
        let maxY=Number.MIN_VALUE;

        // 遍历数组，获取节点坐标,计算比例因子
        let positionArray=[];
        for(let item of links){
            let first=item.first;
            let positionF=first.position;
            positionArray.push(positionF);

            let second=item.second;
            let positionS=second.position;
            positionArray.push(positionS);
        }
        // 便利获取范围值
        for(let item of positionArray){
            let x=item.x;
            let y=item.y;
            if(x<minX)
                minX=x;
            if(y<minY)
                minY=y;
            if(x>maxX)
                maxX=x;
            if(y>maxY)
                maxY=y;
        }

        let w=this.$el.offsetWidth;
        let h=this.$el.offsetHeight;

        let bounds={
            minX:minX,
            minY:minY,
            maxX:maxX,
            maxY:maxY,
            height:Math.floor((maxY-minY) * 100) / 100,
            width:Math.floor((maxX-minX) * 100) / 100
        }
        // 求比例因子
        let factor =(bounds.width / bounds.height) < (w / h) ? h / bounds.height : w / bounds.width;

        let dx = bounds.minX;
        let dy = bounds.minY;
        let dwidth = Math.abs(bounds.maxX - bounds.maxX);
        let dheight = Math.abs(bounds.maxY - bounds.minY);

        factor *= .9;

        dx += dwidth * .5 - w * 0.5 / factor;
        dy += dheight * .5 - h * 0.5 / factor;

        // 绘制节点
        // for(let item of nodes){
        //     let position=item.position;
        //     let x=position.x;
        //     let y=position.y;
        //     x=(x - dx) * factor;
        //     y=(y-dy)*factor;
        //     // 创建点
        //     let f=new Feature({
        //         geometry:new Point([x,y])
        //     });
        //     // 加入到地图上去
        //     source.addFeature(f);
        // }

        // 绘制连线
        let lines=[];
        let i=0;
        for(let link of links){
            // 构建第一个点
            let first=link.first;
            let position=first.position;
            let x=position.x;
            let y=position.y;
            x=(x - dx) * factor;
            y=(y-dy)*factor;
            let firstPoint=[x,y];
            // 将pixel坐标转为地理坐标
            // firstPoint=[x,-y]
            firstPoint=this.map.getCoordinateFromPixel(firstPoint);
            firstPoint=[firstPoint[0],-firstPoint[1]]
            
            // 构建第二个点
            let second=link.second;
            position=second.position;
            x=position.x;
            y=position.y;
            x=(x - dx) * factor;
            y=(y-dy)*factor;
            let secondPoint=[x,y];
            // 将pixel坐标转为地理坐标
            // secondPoint=[x,-y];
            secondPoint=this.map.getCoordinateFromPixel(secondPoint);
            secondPoint=[secondPoint[0],-secondPoint[1]];
            
            // 创建直线
            let f=new Feature({
                geometry:new LineString([firstPoint,secondPoint]),
                _node_type:10,
                _type:"line",
                id:i
            });
            // 加入到地图上去
            source.addFeature(f);
            // 保存管道
            lines.push(f);
            i++;
        }
        this.lines=lines;

        // 通知全局管线事件
        let a_lines=store.state.simulation.lines;
        a_lines=a_lines.concat(lines);
        // 设置全局的管道
        store.commit("simulation/setLines",lines);
    }
    /** 保存管道 */
    save(){
        // json的格式，详见Readme.md文件
        let filejson=JSON.parse(JSON.stringify(drawjson));
        // 设置导出类型
        filejson.type=store.state.simulation.simutype;
        // 遍历地图上的图形，进行属性json文件的生成
        let source=this.drawSource;
        let features=source.getFeatures();

        let ignores=['geometry','lines','first_point','last_point','img','devices'];  // 需要忽略的属性

        for(let item of features){
            let nodeProps=item.getProperties();
            let geom=item.getGeometry();
            let _node_type=nodeProps._node_type;
            let id=nodeProps.id;
            let temp=[];

            // 去掉不必须的属性
            let props={};
            for(let key in nodeProps){
                if(ignores.indexOf(key)>=0){
                    continue;
                }
                props[key]=nodeProps[key];
            }           

            switch(_node_type){
                case 10: // 管道节点
                    let first=geom.getFirstCoordinate();
                    let last=geom.getLastCoordinate();
                    // 获取节点编号
                    let node1=nodeProps.node1||"";
                    let first_point=this.drawSource.getFeatureById(node1);
                    let node1Id="";
                    if(first_point){
                        node1Id=first_point.get("id");
                    }

                    let node2Id="";
                    // let last_point=nodeProps['last_point'];
                    let node2=nodeProps.node2||"";
                    let last_point=this.drawSource.getFeatureById(node2);
                    if(last_point){
                        node2Id=last_point.get("id");
                    }
                    // 保存数据
                    temp=[id,node1Id,node2Id,first[0],first[1],last[0],last[1]];
                    filejson.pipes.data.push(temp);

                    // 保存属性
                    filejson.pipes.properities[id]=props;
                break;
                case 0: // 节点类型0
                case 1: // 节点类型1
                    let point=geom.getCoordinates();
                    temp=[id,_node_type,point[0],point[1]];
                    filejson.nodes.data.push(temp);
                    // 增加nodeType
                    props.nodeType=nodeProps.name;
                    // 保存属性
                    filejson.nodes.properities[id]=props;
                break;
                case 2:// 设备节点
                    let point_d=geom.getCoordinates();
                    // 获取绑定的线段
                    let lines=item.get("lines");
                    if(lines){
                        let lineProp=lines[0].getProperties();
                        let lineId=lineProp.id;
                        temp=[id,lineId,point_d[0],point_d[1]];
                        filejson.devices.data.push(temp);
                    }
                    // 保存属性
                    filejson.devices.properities[id]=props;
                break;
            }
        }
        return filejson;
    }

    // 读取json文件
    open(filejson){
        // 图层源
        let source=this.drawSource;

        // 设置打开类型
        let simutype=filejson.type||store.state.simulation.simutype; // 文件类型
        store.commit("simulation/setSimutype",simutype);

        // 范围
        let extent=createEmpty();

        // 绘制管道
        let pipes=filejson.pipes;
        let data=pipes.data;
        let props=pipes.properities;
        let lines={};
        for(let item of data){
            let firstPoint=[item[3],item[4]];
            let secondPoint=[item[5],item[6]];
            let id=item[0];            
            // 创建直线
            let f=new Feature({
                geometry:new LineString([firstPoint,secondPoint]),
                _node_type:10,
                _type:"line",
                id:id
            });
            // 挂载属性信息
            let p=props[id];
            f.setProperties(p);
            // 设置id号，为什么要调用setId和set("id"),这是因为如果设置了set("id")，那么getId的时候就找不到id号
            let fid=generateID();
            f.setId(fid);

            // 加入到地图上去
            source.addFeature(f);
            // 保存管道
            lines[id]={
                feature:f,
                node1:item[1],
                node2:item[2],
            };

            // 保存范围
            let tempExt=boundingExtent([firstPoint,secondPoint]);
            extent=extend(extent,tempExt);
        }
        this.lines=lines;

        // 绘制节点
        let nodes=filejson.nodes;
        data=nodes.data;
        props=nodes.properities;
        let tempnodes={};
        for(let item of data){
            let firstPoint=[item[2],item[3]];
            let node_type=item[1];           
            // 创建节点
            let id=item[0];
            let f=new Feature({
                geometry:new Point(firstPoint),
                _node_type:node_type,
                id:id
            });
            // 挂载属性信息
            let p=props[id];

            // 设置图片
            let nodeType=p._type;
            let nodeImg=this.findNode(nodeType);
            p=Object.assign(p,nodeImg);
            f.setProperties(p);
            // 设置id号，为什么要调用setId和set("id"),这是因为如果设置了set("id")，那么getId的时候就找不到id号
            let fid=generateID();
            f.setId(fid);

            // 加入到地图上去
            source.addFeature(f);
            // 保存管道
            tempnodes[id]={
                feature:f,
            };

            // 保存范围
            let tempExt=boundingExtent([firstPoint]);
            extent=extend(extent,tempExt);
        }
        this.nodes=tempnodes;

        // 绘制设备
        let devices=filejson.devices;
        data=devices.data;
        let tempDevices={};
        props=devices.properities;
        // tempnodes={};
        for(let item of data){
            let firstPoint=[item[2],item[3]];          
            // 创建节点
            let id=item[0];
            let f=new Feature({
                geometry:new Point(firstPoint),
                _node_type:2,
                id:id
            });
            // 设置id号，为什么要调用setId和set("id"),这是因为如果设置了set("id")，那么getId的时候就找不到id号
            let fid=generateID();
            f.setId(fid);
            // 挂载属性信息
            let p=props[id];

            // 设置图片
            let nodeType=p._type;
            let nodeImg=this.findNode(nodeType);
            p=Object.assign(p,nodeImg);
            f.setProperties(p); 

            // 加入到地图上去
            source.addFeature(f);
            // 保存设备信息
            tempDevices[id]={
                feature:f,
                pipeid:item[1],
            };

            // 保存范围
            let tempExt=boundingExtent([firstPoint]);
            extent=extend(extent,tempExt);
        }
        this.devices=tempDevices;

        // 地图缩放到全局
        this.map.getView().fit(extent,{
            padding:[40,40,40,40]
        });

        // 进行节点和管线关连
        for(let lineid in lines){   
            let item=lines[lineid];
            let node1=item.node1;
            // 存在关连的第一个节点
            if(node1||node1===0){
                let point=tempnodes[node1].feature;
                let lineFeature=item.feature;
                lineFeature.set("node1",point.getId()); // 线关连点 
                // 点关连线
                let pointlines=point.get("lines");
                if(!pointlines){
                    pointlines=[];
                }
                pointlines.push(lineFeature.getId());
                point.set("lines",pointlines);
            }

            let node2=item.node2;
            if(node2||node2===0){
                let point=tempnodes[node2].feature;
                let lineFeature=item.feature;
                lineFeature.set("node2",point.getId()); // 线关连点

                // 点关连线
                let pointlines=point.get("lines");
                if(!pointlines){
                    pointlines=[];
                }
                pointlines.push(lineFeature.getId());
                point.set("lines",pointlines);
            }
        }

        // 进行设备和管线关连
        for(let itemid in tempDevices){
            let item=tempDevices[itemid];
            let device=item.feature;
            let pipeid=item.pipeid;
            let lineFeature=lines[pipeid].feature;

            // 线关连点
            let devices=lineFeature.get("devices");
            if(!devices){
                devices=[];
            }
            devices.push(device.getId());
            lineFeature.set("devices",devices); 

            // 点关连线
            let pointlines=device.get("lines");
            if(!pointlines){
                pointlines=[];
            }
            pointlines.push(lineFeature);
            device.set("lines",pointlines);
        }

        // 记录快照
        store.commit("simulation/recordSnapshot");
    }

    // 导出
    export(){
        // 获取当前的计算介质类型
        let simutype=store.state.simulation.simutype;
        let result="";
        switch(simutype){
            case "steam":
                result=this.exportSteam();
                break;
            case "water":
                result=this.exportWater();
                break;
            case "insulationWater":
                result=this.exportInsulationWater();
                break;
        }
        return result;
    }
    // 导出蒸汽
    exportSteam(){
        /**
         * json的格式，详见Readme.md和FileFormat文件
         */
        let filejson=JSON.parse(JSON.stringify(steamjson));
        // 遍历地图上的图形，进行属性json文件的生成
        let source=this.drawSource;
        let features=source.getFeatures();

        // 管道属性默认信息
        let linesProps={
            "id": 0, // 编号
            "name": "pipe", // 名称
            "pipeModel":store.state.simulation.globalConfig.pipeModel,  // 管道尺寸
            "insulaSet":store.state.simulation.globalConfig.insulaSet   // 管道保温
        }

        let ignores=['geometry','_node_type','lines','first_point','last_point','img','_type','devices','_shape'];  // 需要忽略的属性
        for(let item of features){
            let nodeProps=item.getProperties();
            let geom=item.getGeometry();
            let node_type_=nodeProps._node_type;
            let id=nodeProps.id;
            let temp=[];

            // 去掉不必须的属性
            let props={};
            for(let key in nodeProps){
                if(ignores.indexOf(key)>=0){
                    continue;
                }
                props[key]=nodeProps[key];
            }
            // 根据不同的节点类型，导出不同的属性信息
            switch(node_type_){
                case 10: // 管道节点
                    let first=geom.getFirstCoordinate();
                    let last=geom.getLastCoordinate();
                    // 获取节点编号
                    let node1=nodeProps.node1||"";
                    let first_point=this.drawSource.getFeatureById(node1);
                    let node1Id="";
                    if(first_point){
                        node1Id=first_point.get("id");
                    }

                    let node2Id="";
                    let node2=nodeProps.node2||"";
                    let last_point=this.drawSource.getFeatureById(node2);
                    if(last_point){
                        node2Id=last_point.get("id");
                    }
                    // 保存数据
                    temp=[id,node1Id,node2Id,first[0],first[1],last[0],last[1]];
                    filejson.pipes.data.push(temp);

                    // 如果不存在管道默认属性，则需要添加
                    if(!props.hasOwnProperty("pipeModel")){
                        props["pipeModel"]=linesProps["pipeModel"];
                    }
                    if(!props.hasOwnProperty("insulaSchemeId")){
                        props["insulaSchemeId"]=linesProps['insulaSet']["id"];
                    }

                    // 保存属性
                    filejson.pipes.properities[id]=props;
                break;
                case 0: // 节点类型0
                case 1: // 节点类型1
                    let point=geom.getCoordinates();
                    temp=[id,node_type_,point[0],point[1]];
                    filejson.nodes.data.push(temp);
                    // 增加nodeType
                    props.nodeType=nodeProps.name;
                    // 保存属性
                    filejson.nodes.properities[id]=props;
                break;
                case 2:// 设备节点
                    let point_d=geom.getCoordinates();
                    // 获取绑定的线段
                    let lines=item.get("lines");
                    if(lines){
                        let lID=lines[0]||"";
                        let line=this.drawSource.getFeatureById(lID);
                        let lineProp=line.getProperties();
                        let lineId=lineProp.id;
                        temp=[id,lineId,point_d[0],point_d[1]];
                        filejson.devices.data.push(temp);
                    }
                    // 增加nodeType
                    props.nodeType=nodeProps.name;
                    // 保存属性
                    filejson.devices.properities[id]=props;
                break;
            }
        }
        // 剩余的全局性配置
        filejson.tempePressRangeSet=store.state.simulation.globalConfig.tempePressRangeSet;
        return filejson;
    }
    // 导出水
    exportWater(){
        // json的格式，详见Readme.md和FileFormat文件
        let filejson=JSON.parse(JSON.stringify(waterjson));
        // 遍历地图上的图形，进行属性json文件的生成
        let source=this.drawSource;
        let features=source.getFeatures();

        // 如果这个节点包含了温度、压强或者是流量，则需要单独在 nodeDemand 节点中标出
        let tempNodeDemand={header:[],data:[]};
        // 默认值设置
        let defaultValue={
            pipes:this.getDefault("waterLine"),
            nodes:this.getDefault("branch"),
            reservoirs:this.getDefault("reservoir"),
            tanks:this.getDefault("tank"),
            valves:this.getDefault("valve"),
        };

        for(let item of features){
            let nodeProps=item.getProperties(); // 图形的属性信息
            let _type=nodeProps._type; // 类型

            // 只保留节点、水库、水池、阀门和管道的属性信息
            let lines=null;
            switch(_type){
                case "line": // 管道
                    let node1=nodeProps.node1||"";
                    let first_point=this.drawSource.getFeatureById(node1); // 前一个节点
                    let node2=nodeProps.node2||"";
                    let last_point=this.drawSource.getFeatureById(node2); // 后一个节点
                    /**
                     * 1.判断管道是输出，管道的前后两个节点，必须是 branch、reservoir、tank节点。
                     * 2.判断  branch、reservoir、tank、tank节点是否输出，必须关联管道
                     */
                    if(first_point&&last_point){
                        let fi_type=first_point.get("_type"); // 获取关联节点的类型
                        let la_type=first_point.get("_type"); // 获取关联节点的类型
                        if((fi_type=="branch"||fi_type=="reservoir"||fi_type=="tank")&&
                            (la_type=="branch"||la_type=="reservoir"||la_type=="tank")){
                            // 保存管道信息
                            let line_header=filejson.pipe.header;
                            let tempdata=[];
                            for(let name of line_header){
                                let result=0; // 结果数据
                                if(name=="node1"){ // 设置 前后两个节点的编号
                                    result=first_point.get("id");
                                }else if(name=="node2"){
                                    result=last_point.get("id");
                                }else{
                                    result=nodeProps[name]||defaultValue.pipes[name];
                                }
                                // 保存数据
                                tempdata.push(this.transformDigital(result));
                            }
                            filejson.pipe.data.push(tempdata);

                            // 保存绘图信息
                            this.saveDrawInfo(item,filejson);
                        }
                    }
                    
                    break;
                case "branch": // 管道节点
                    /**
                     * 如果只有节点，没有管道，则放弃该节点
                     * 否则，根据json格式要求，填写数据属性
                     */
                    lines=nodeProps.lines;
                    if(lines&&lines.length>0){
                        let branch_header=filejson.node.header;
                        let tempdata=[];
                        for(let name of branch_header){
                            let result=nodeProps[name]||defaultValue.nodes[name]||0;
                            // 保存数据
                            tempdata.push(this.transformDigital(result));
                        }
                        // 输出属性信息
                        filejson.node.data.push(tempdata);
                        
                        // 如果这个节点包含了温度、压强或者是流量，则需要单独在 nodeDemand 节点中标出
                        // 压力
                        if(nodeProps.hasOwnProperty("pressure")){
                            if(tempNodeDemand.header.indexOf("pressure")<0){
                                tempNodeDemand.header.push("pressure");
                            }
                            tempNodeDemand.data.push(nodeProps);
                        }
                        // 温度
                        if(nodeProps.hasOwnProperty("temperature")){
                            if(tempNodeDemand.header.indexOf("temperature")<0){
                                tempNodeDemand.header.push("temp");
                            }
                            tempNodeDemand.data.push(nodeProps);
                        }
                        // 流量
                        if(nodeProps.hasOwnProperty("flux")){
                            if(tempNodeDemand.header.indexOf("flux")<0){
                                tempNodeDemand.header.push("flux");
                            }
                            tempNodeDemand.data.push(nodeProps);
                        }

                        // 保存绘图信息
                        this.saveDrawInfo(item,filejson);
                    }
                    break;
                case "reservoir": // 水库
                    /**
                     * 如果只有节点，没有管道，则放弃该节点
                     * 否则，根据json格式要求，填写数据属性
                     */
                     lines=nodeProps.lines;
                     if(lines&&lines.length>0){
                        let branch_header=filejson.reservior.header;
                        let tempdata=[];
                        for(let name of branch_header){
                            let result=nodeProps[name]||defaultValue.reserviors[name]||0;
                            tempdata.push(this.transformDigital(result));
                        }
                        // 输出属性信息
                        filejson.reservior.data.push(tempdata);

                        // 保存绘图信息
                        this.saveDrawInfo(item,filejson);
                     }
                    break;
                case "tank":// 水池
                    /**
                     * 如果只有节点，没有管道，则放弃该节点
                     * 否则，根据json格式要求，填写数据属性
                     */
                     lines=nodeProps.lines;
                     if(lines&&lines.length>0){
                        let branch_header=filejson.tank.header;
                        let tempdata=[];
                        for(let name of branch_header){
                            let result=nodeProps[name]||defaultValue.tanks[name]||0;
                            tempdata.push(this.transformDigital(result));
                        }
                        // 输出属性信息
                        filejson.tank.data.push(tempdata);
                        // 保存绘图信息
                        this.saveDrawInfo(item,filejson);
                     }
                    break;
                case "valve":// 阀门
                    /**
                     * 如果只有节点，没有管道，则放弃该节点，并且管道前后两个节点必须存在，且类型必须是 branch、reservoir、tank、tank节点
                     * 否则，根据json格式要求，填写数据属性
                     */
                     lines=nodeProps.lines;
                     if(lines&&lines.length>0){
                        let line=lines[0]; // 获取绑定的管道信息
                        let linesProps=line.getProperties(); // 图形的属性信息
                        let node1=linesProps.node1||"";
                        let first_point=this.drawSource.getFeatureById(node1); // 前一个节点
                        let node2=linesProps.node2||"";
                        let last_point=this.drawSource.getFeatureById(node2); // 后一个节点
                        // 存在前后两个节点，并且前后两个节点，必须是 branch 类型
                        if(first_point&&last_point){
                            let br_type=first_point.get("_type");
                            let la_type=last_point.get("_type");
                            if((br_type=="branch"||br_type=="reservoir"||br_type=="tank")&&
                            (la_type=="branch"||la_type=="reservoir"||la_type=="tank")){
                                let branch_header=filejson.valve.header;
                                let tempdata=[];
                                for(let name of branch_header){
                                    let result=0;
                                    if(name=="node1"){ // 设置 前后两个节点的编号
                                        result=first_point.get("id");
                                    }else if(name=="node2"){
                                        result=last_point.get("id");
                                    }else{
                                        result=nodeProps[name]||defaultValue.valves[name]||0;
                                    }
                                    tempdata.push(this.transformDigital(result));
                                }
                                // 输出属性信息
                                filejson.valve.data.push(tempdata);
                                // 保存绘图信息
                                this.saveDrawInfo(item,filejson);
                            }
                        }  
                     }
                    break;
            }
        }

        // 根据是否包含这几个值确定是否显示 nodeDemand 节点
        if(tempNodeDemand.header.length>0){
            let nodeDemand={
                header:["id"],
                data:[],
            }
            nodeDemand.header=nodeDemand.header.concat(tempNodeDemand.header);
            for(let item of tempNodeDemand.data){
               let tempData=[];
               tempData.push(parseInt(item.id));
               for(let key of tempNodeDemand.header){
                    tempData.push(this.transformDigital(item[key]||0));
               }
               nodeDemand.data.push(tempData);
            }
            // 保存
            filejson.nodeDemand=nodeDemand;
        }
        return filejson;
    }
    // 导出保温水
    exportInsulationWater(){
        // json的格式，详见Readme.md和FileFormat文件
        let filejson=JSON.parse(JSON.stringify(insulationWaterjson));
        // 遍历地图上的图形，进行属性json文件的生成
        let source=this.drawSource;
        let features=source.getFeatures();

        // 如果这个节点包含了温度、压强或者是流量，则需要单独在 nodeDemand 节点中标出
        let tempNodeDemand={header:[],data:[]};

        // 默认值设置
        let defaultValue={
            pipes:this.getDefault("waterLine"),
            nodes:this.getDefault("branch"),
            reservoir:this.getDefault("reservoir"),
            tank:this.getDefault("tank"),
            valve:this.getDefault("valve"),
        };

        for(let item of features){
            let nodeProps=item.getProperties(); // 图形的属性信息
            let _type=nodeProps._type; // 类型

            // 只保留节点、水库、水池、阀门和管道的属性信息
            let lines=null;
            switch(_type){
                case "line": // 管道
                    let node1=nodeProps.node1||"";
                    let first_point=this.drawSource.getFeatureById(node1); // 前一个节点
                    let node2=nodeProps.node2||"";
                    let last_point=this.drawSource.getFeatureById(node2); // 后一个节点
                    /**
                     * 1.判断管道是输出，管道的前后两个节点，必须是 branch、reservoir、tank节点。
                     * 2.判断  branch、reservoir、tank、tank节点是否输出，必须关联管道
                     */
                    if(first_point&&last_point){
                        let fi_type=first_point.get("_type"); // 获取关联节点的类型
                        let la_type=first_point.get("_type"); // 获取关联节点的类型
                        if((fi_type=="branch"||fi_type=="reservoir"||fi_type=="tank")&&
                            (la_type=="branch"||la_type=="reservoir"||la_type=="tank")){
                            // 保存管道信息
                            let line_header=filejson.pipe.header;
                            let tempdata=[];
                            for(let name of line_header){
                                let result=0; // 结果数据
                                if(name=="node1"){ // 设置 前后两个节点的编号
                                    result=first_point.get("id");
                                }else if(name=="node2"){
                                    result=last_point.get("id");
                                }else{
                                    // 如果数据存在，则使用数据，否则使用默认值
                                    result=nodeProps[name]||defaultValue.pipes[name]; 
                                }
                                // 保存数据
                                tempdata.push(this.transformDigital(result));
                            }
                            // 保存管道信息
                            filejson.pipe.data.push(tempdata);

                            // 保存管道的保温方案信息

                            // 保存绘图信息
                            this.saveDrawInfo(item,filejson);
                        }
                    }
                    
                    break;
                case "branch": // 管道节点
                    /**
                     * 如果只有节点，没有管道，则放弃该节点
                     * 否则，根据json格式要求，填写数据属性
                     */
                    lines=nodeProps.lines;
                    if(lines&&lines.length>0){
                        let branch_header=filejson.node.header;
                        let tempdata=[];
                        for(let name of branch_header){
                            let result=nodeProps[name]||defaultValue.nodes[name]||0;
                            // 保存数据
                            tempdata.push(this.transformDigital(result));
                        }
                        // 输出属性信息
                        filejson.node.data.push(tempdata);
                        
                        // 如果这个节点包含了温度、压强或者是流量，则需要单独在 nodeDemand 节点中标出
                        // 压力
                        if(nodeProps.hasOwnProperty("pressure")){
                            if(tempNodeDemand.header.indexOf("pressure")<0){
                                tempNodeDemand.header.push("pressure");
                            }
                            tempNodeDemand.data.push(nodeProps);
                        }
                        // 温度
                        if(nodeProps.hasOwnProperty("temperature")){
                            if(tempNodeDemand.header.indexOf("temperature")<0){
                                tempNodeDemand.header.push("temp");
                            }
                            tempNodeDemand.data.push(nodeProps);
                        }
                        // 流量
                        if(nodeProps.hasOwnProperty("flux")){
                            if(tempNodeDemand.header.indexOf("flux")<0){
                                tempNodeDemand.header.push("flux");
                            }
                            tempNodeDemand.data.push(nodeProps);
                        }

                        // 保存绘图信息
                        this.saveDrawInfo(item,filejson);
                    }
                    break;
                case "reservoir": // 水库
                    /**
                     * 如果只有节点，没有管道，则放弃该节点
                     * 否则，根据json格式要求，填写数据属性
                     */
                     lines=nodeProps.lines;
                     if(lines&&lines.length>0){
                        let branch_header=filejson.reservior.header;
                        let tempdata=[];
                        for(let name of branch_header){
                            let result=nodeProps[name]||defaultValue.reservoir[name]||0;
                            tempdata.push(this.transformDigital(result));
                        }
                        // 输出属性信息
                        filejson.reservior.data.push(tempdata);

                        // 保存绘图信息
                        this.saveDrawInfo(item,filejson);
                     }
                    break;
                case "tank":// 水池
                    /**
                     * 如果只有节点，没有管道，则放弃该节点
                     * 否则，根据json格式要求，填写数据属性
                     */
                     lines=nodeProps.lines;
                     if(lines&&lines.length>0){
                        let branch_header=filejson.tank.header;
                        let tempdata=[];
                        for(let name of branch_header){
                            let result=nodeProps[name]||defaultValue.tank[name]||0;
                            tempdata.push(this.transformDigital(result));
                        }
                        // 输出属性信息
                        filejson.tank.data.push(tempdata);
                        // 保存绘图信息
                        this.saveDrawInfo(item,filejson);
                     }
                    break;
                case "valve":// 阀门
                    /**
                     * 如果只有节点，没有管道，则放弃该节点，并且管道前后两个节点必须存在，且类型必须是 branch、reservoir、tank、tank节点
                     * 否则，根据json格式要求，填写数据属性
                     */
                     lines=nodeProps.lines;
                     if(lines&&lines.length>0){
                        let line=lines[0]; // 获取绑定的管道信息
                        let linesProps=line.getProperties(); // 图形的属性信息
                        let node1=linesProps.node1||"";
                        let first_point=this.drawSource.getFeatureById(node1); // 前一个节点
                        let node2=linesProps.node2||"";
                        let last_point=this.drawSource.getFeatureById(node2); // 后一个节点
                        // 存在前后两个节点，并且前后两个节点，必须是 branch 类型
                        if(first_point&&last_point){
                            let br_type=first_point.get("_type");
                            let la_type=last_point.get("_type");
                            if((br_type=="branch"||br_type=="reservoir"||br_type=="tank")&&
                            (la_type=="branch"||la_type=="reservoir"||la_type=="tank")){
                                let branch_header=filejson.valve.header;
                                let tempdata=[];
                                for(let name of branch_header){
                                    let result=0;
                                    if(name=="node1"){ // 设置 前后两个节点的编号
                                        result=first_point.get("id");
                                    }else if(name=="node2"){
                                        result=last_point.get("id");
                                    }else{
                                        result=nodeProps[name]||defaultValue.valve[name]||0;
                                    }
                                    tempdata.push(this.transformDigital(result));
                                }
                                // 输出属性信息
                                filejson.valve.data.push(tempdata);
                                // 保存绘图信息
                                this.saveDrawInfo(item,filejson);
                            }
                        }  
                     }
                    break;
            }
        }

        // 根据是否包含这几个值确定是否显示 nodeDemand 节点
        if(tempNodeDemand.header.length>0){
            let nodeDemand={
                header:["id"],
                data:[],
            }
            nodeDemand.header=nodeDemand.header.concat(tempNodeDemand.header);
            for(let item of tempNodeDemand.data){
               let tempData=[];
               tempData.push(parseInt(item.id));
               for(let key of tempNodeDemand.header){
                    tempData.push(this.transformDigital(item[key]||0));
               }
               nodeDemand.data.push(tempData);
            }
            // 保存
            filejson.nodeDemand=nodeDemand;
        }

        /**
         * 保存保温方案和保温材料
         */
        // 保温方案
        let globalConfig=store.state.simulation.globalConfig;
        let insulaSchemeSugs=globalConfig.insulaSchemeSugs; // 系统结果
        let insulaSchemeResult=filejson.insulaScheme; // 输出保温方案结果
        let insulaSchemeHeader=insulaSchemeResult.header;
        let insulaSchemeData=[]; // 保温方案结果数组
        for(let scheme of insulaSchemeSugs){
            let temp=[];
            temp.push(scheme.id); // 方案id
            temp.push(scheme.insulaNumber); // 保温层数

            let insulaScheme=scheme.insulaScheme;
            temp.push(insulaScheme[0]?insulaScheme[0].insulaMaterialId:null); // 第一层保温材料id
            temp.push(insulaScheme[0]?insulaScheme[0].insulaThick:null); // 第一层保温材料壁厚

            temp.push(insulaScheme[1]?insulaScheme[1].insulaMaterialId:null); // 第二层保温材料id
            temp.push(insulaScheme[1]?insulaScheme[1].insulaThick:null); // 第二层保温材料壁厚

            temp.push(insulaScheme[2]?insulaScheme[2].insulaMaterialId:null); // 第三层保温材料id
            temp.push(insulaScheme[2]?insulaScheme[2].insulaThick:null); // 第三层保温材料壁厚

            temp.push(insulaScheme[3]?insulaScheme[3].insulaMaterialId:null); // 第四层保温材料id
            temp.push(insulaScheme[3]?insulaScheme[3].insulaThick:null); // 第四层保温材料壁厚

            insulaSchemeData.push(temp);
        }
        // 导出数据
        filejson.insulaScheme.data=insulaSchemeData;




        // 保温材料
        let insulaMaterialResult=filejson.insulaMaterial; // 保存结果
        let materialHeader=insulaMaterialResult.header;
        let insulaMaterialSugs=globalConfig.insulaMaterialSugs; // 材料列表
        let insulaMaterialData=[];
        for(let insulaMaterial of insulaMaterialSugs){
            let tempdata=[];
            for(let name of materialHeader){
                let result=0;
                if(name=="insulaTypeId"){ // 设置 前后两个节点的编号
                    result=insulaMaterial.id;
                }else{
                    result=insulaMaterial[name]||0;
                }
                tempdata.push(this.transformDigital(result));
            }
            insulaMaterialData.push(tempdata);
        }
        // 导出数据
        filejson.insulaMaterial.data=insulaMaterialData;

        return filejson;
    }
    // 导入
    import(filejson){
        // 根据最新的导出文件格式，变化了
        try{
            filejson=JSON.parse(filejson);
        }catch(e){

        }
        if(!filejson.public){
            return;
        }
        let index=filejson.public.header.indexOf("medium");
        let simutype=filejson.public.data[0][index]||store.state.simulation.simutype; // 文件类型

        store.commit("simulation/setSimutype",simutype);
        // 获取当前的计算介质类型
        let result="";
        switch(simutype){
            case "steam":
                result=this.importSteam(filejson);
                break;
            case "water":
                result=this.importWater(filejson);
                break;
        }
        // 记录快照
        store.commit("simulation/recordSnapshot");

        return result;
    }
    // 导入蒸汽文件
    importSteam(){
        // 图层源
        let source=this.drawSource;
        // 范围
        let extent=createEmpty();

        // 绘制管道
        let pipes=filejson.pipescoor;
        let data=pipes.data;
        let props=pipes.properities||{}; // 属性信息
        let lines={};
        for(let item of data){
            let firstPoint=[item[3],item[4]];
            let secondPoint=[item[5],item[6]];
            let id=item[0];            
            // 创建直线
            let f=new Feature({
                geometry:new LineString([firstPoint,secondPoint]),
                _node_type:10,
                _type:"line",
                id:id
            });

            // 挂载属性信息
            let p=props[id]||{};
            f.setProperties(p);
            // 设置仿真结果图形类型
            f.set("_shape","pipe");
            // 设置id号，为什么要调用setId和set("id"),这是因为如果设置了set("id")，那么getId的时候就找不到id号
            let fid=generateID();
            f.setId(fid);


            // 加入到地图上去
            source.addFeature(f);
            // 保存管道
            lines[id]={
                feature:f,
                node1:item[1],
                node2:item[2],
            };

            // 保存范围
            let tempExt=boundingExtent([firstPoint,secondPoint]);
            extent=extend(extent,tempExt);
        }
        this.lines=lines;

        // 绘制节点
        let nodes=filejson.nodescoor;
        data=nodes.data;
        props=nodes.properities||{}; // 属性信息
        let tempnodes={};
        for(let item of data){
            let firstPoint=[item[3],item[4]];
            let node_type=item[1];           
            // 创建节点
            let id=item[0];
            let f=new Feature({
                geometry:new Point(firstPoint),
                _node_type:node_type,
                id:id
            });
            // 挂载属性信息
            let p=props[id]||{};
            // 设置图片
            let nodeType=item[2]; // 类型
            let nodeImg=this.findNode(nodeType);
            p=Object.assign(p,nodeImg);
            f.setProperties(p);
            // 设置仿真结果图形类型
            f.set("_shape","node");
            // 设置id号，为什么要调用setId和set("id"),这是因为如果设置了set("id")，那么getId的时候就找不到id号
            let fid=generateID();
            f.setId(fid);

            // 加入到地图上去
            source.addFeature(f);
            // 保存管道
            tempnodes[id]={
                feature:f,
            };

            // 保存范围
            let tempExt=boundingExtent([firstPoint]);
            extent=extend(extent,tempExt);
        }
        this.nodes=tempnodes;

        // 绘制设备
        let devices=filejson.devicescoor;
        data=devices.data;
        let tempDevices={};
        props=devices.properities||{}; // 属性信息
        for(let item of data){
            let firstPoint=[item[3],item[4]];          
            // 创建节点
            let id=item[0];
            let f=new Feature({
                geometry:new Point(firstPoint),
                _node_type:2,
                id:id
            });

            // 挂载属性信息
            let p=props[id]||{};
            // 设置图片
            let nodeType=item[2];
            let nodeImg=this.findNode(nodeType);
            p=Object.assign(p,nodeImg);
            f.setProperties(p);
            // 设置仿真结果图形类型
            f.set("_shape","node");
            // 设置id号，为什么要调用setId和set("id"),这是因为如果设置了set("id")，那么getId的时候就找不到id号
            let fid=generateID();
            f.setId(fid);

            // 加入到地图上去
            source.addFeature(f);
            // 保存设备信息
            tempDevices[id]={
                feature:f,
                pipeid:item[1],
            };

            // 保存范围
            let tempExt=boundingExtent([firstPoint]);
            extent=extend(extent,tempExt);
        }
        this.devices=tempDevices;

        // 地图缩放到全局
        this.map.getView().fit(extent,{
            padding:[25,25,25,25]
        });

        // 进行节点和管线关连
        for(let lineid in lines){   
            let item=lines[lineid];
            let node1=item.node1;
            // 存在关连的第一个节点
            if(node1||node1===0){
                let point=tempnodes[node1].feature;
                let lineFeature=item.feature;
                lineFeature.set("node1",point.getId()); // 线关连点 
                // 点关连线
                let pointlines=point.get("lines");
                if(!pointlines){
                    pointlines=[];
                }
                pointlines.push(lineFeature.getId());
                point.set("lines",pointlines);
            }

            let node2=item.node2;
            if(node2||node2===0){
                let point=tempnodes[node2].feature;
                let lineFeature=item.feature;
                lineFeature.set("node2",point.getId()); // 线关连点

                // 点关连线
                let pointlines=point.get("lines");
                if(!pointlines){
                    pointlines=[];
                }
                pointlines.push(lineFeature.getId());
                point.set("lines",pointlines);
            }
        }

        // 进行设备和管线关连
        for(let itemid in tempDevices){
            let item=tempDevices[itemid];
            let device=item.feature;
            let pipeid=item.pipeid;
            let lineFeature=lines[pipeid].feature;

            // 线关连点
            let devices=lineFeature.get("devices");
            if(!devices){
                devices=[];
            }
            devices.push(device.getId());
            lineFeature.set("devices",devices); 

            // 点关连线
            let pointlines=device.get("lines");
            if(!pointlines){
                pointlines=[];
            }
            pointlines.push(lineFeature.getId());
            device.set("lines",pointlines);
        }
    }
    // 导入水文件
    importWater(filejson){
        // 图层源
        let source=this.drawSource;

        // 范围
        let extent=createEmpty();

        // 绘制管道
        let pipes=filejson.pipescoor;
        let data=pipes.data;

        // 将属性数组转换为属性对象
        let props=this.transformProperties(filejson.pipe.data,filejson.pipe.header);
        
        let lines={};
        for(let item of data){
            let firstPoint=[item[3],item[4]];
            let secondPoint=[item[5],item[6]];
            let id=item[0];            
            // 创建直线
            let f=new Feature({
                geometry:new LineString([firstPoint,secondPoint]),
                _node_type:10,
                _type:"line",
                id:id
            });
            // 挂载属性信息
            let p=props[id]||{};
            f.setProperties(p);
            // 设置仿真结果图形类型
            f.set("_shape","pipe");
            // 设置id号，为什么要调用setId和set("id"),这是因为如果设置了set("id")，那么getId的时候就找不到id号
            let fid=generateID();
            f.setId(fid);


            // 加入到地图上去
            source.addFeature(f);
            // 保存管道
            lines[id]={
                feature:f,
                node1:item[1],
                node2:item[2],
            };

            // 保存范围
            let tempExt=boundingExtent([firstPoint,secondPoint]);
            extent=extend(extent,tempExt);
        }
        this.lines=lines;

        // 绘制节点
        let nodes=filejson.nodescoor;
        data=nodes.data;
        // 将属性数组转换为属性对象
        let type=["node","reservior","tank","valve"];
        props={}; // 属性信息
        for(let t of type){
            props=Object.assign(props,this.transformProperties(filejson[t].data,filejson[t].header));
        }

        let tempnodes={};
        for(let item of data){
            let firstPoint=[item[3],item[4]];
            let node_type=item[1];           
            // 创建节点
            let id=item[0];
            let f=new Feature({
                geometry:new Point(firstPoint),
                _node_type:node_type,
                id:id
            });
            // 挂载属性信息
            let p=props[id]||{};
            // 设置图片
            let nodeType=item[2]; // 类型
            let nodeImg=this.findNode(nodeType);
            p=Object.assign(p,nodeImg);
            f.setProperties(p);
            // 设置仿真结果图形类型
            f.set("_shape","node");
            // 设置id号，为什么要调用setId和set("id"),这是因为如果设置了set("id")，那么getId的时候就找不到id号
            let fid=generateID();
            f.setId(fid);

            // 加入到地图上去
            source.addFeature(f);
            // 保存管道
            tempnodes[id]={
                feature:f,
            };

            // 保存范围
            let tempExt=boundingExtent([firstPoint]);
            extent=extend(extent,tempExt);
        }
        this.nodes=tempnodes;

        // 地图缩放到全局
        this.map.getView().fit(extent,{
            padding:[25,25,25,25]
        });

        // 绘制设备
        let devices=filejson.devicescoor;
        data=devices.data;
        let tempDevices={};
        for(let item of data){
            let firstPoint=[item[3],item[4]];          
            // 创建节点
            let id=item[0];
            let f=new Feature({
                geometry:new Point(firstPoint),
                _node_type:2,
                id:id
            });
            // 挂载属性信息
            let p=props[id]||{};
            // 设置图片
            let nodeType=item[2];
            let nodeImg=this.findNode(nodeType);
            p=Object.assign(p,nodeImg);
            f.setProperties(p);
            // 设置仿真结果图形类型
            f.set("_shape","pipe");
            // 设置id号，为什么要调用setId和set("id"),这是因为如果设置了set("id")，那么getId的时候就找不到id号
            let fid=generateID();
            f.setId(fid);

            // 加入到地图上去
            source.addFeature(f);
            // 保存设备信息
            tempDevices[id]={
                feature:f,
                pipeid:item[1],
            };

            // 保存范围
            let tempExt=boundingExtent([firstPoint]);
            extent=extend(extent,tempExt);
        }
        this.devices=tempDevices;

        // 进行节点和管线关连
        for(let lineid in lines){   
            let item=lines[lineid];
            let node1=item.node1;
            // 存在关连的第一个节点
            if(node1||node1===0){
                let point=tempnodes[node1].feature;
                let lineFeature=item.feature;
                lineFeature.set("node1",point.getId()); // 线关连点 
                // 点关连线
                let pointlines=point.get("lines");
                if(!pointlines){
                    pointlines=[];
                }
                pointlines.push(lineFeature.getId());
                point.set("lines",pointlines);
            }

            let node2=item.node2;
            if(node2||node2===0){
                let point=tempnodes[node2].feature;
                let lineFeature=item.feature;
                lineFeature.set("node2",point.getId()); // 线关连点

                // 点关连线
                let pointlines=point.get("lines");
                if(!pointlines){
                    pointlines=[];
                }
                pointlines.push(lineFeature.getId());
                point.set("lines",pointlines);
            }
        }

        // 进行设备和管线关连
        for(let itemid in tempDevices){
            let item=tempDevices[itemid];
            let device=item.feature;
            let pipeid=item.pipeid;
            let lineFeature=lines[pipeid].feature;

            // 线关连点
            let devices=lineFeature.get("devices");
            if(!devices){
                devices=[];
            }
            devices.push(device.getId());
            lineFeature.set("devices",devices); 

            // 点关连线
            let pointlines=device.get("lines");
            if(!pointlines){
                pointlines=[];
            }
            pointlines.push(lineFeature.getId());
            device.set("lines",pointlines);
        }
    }

    // 保存绘图信息
    saveDrawInfo(item,filejson){
        let nodeProps=item.getProperties(); // 图形的属性信息
        let geom=item.getGeometry(); // 图形信息
        
        let id=nodeProps.id; // id号
        let temp=[];

        // 保留绘图信息
        let _node_type=nodeProps._node_type; // 节点类型
        let _type=nodeProps._type; // 类型
        switch(_node_type){
            case 10: // 管道节点
                let first=geom.getFirstCoordinate();
                let last=geom.getLastCoordinate();
                // 获取节点编号
                let node1=nodeProps.node1||"";
                let first_point=this.drawSource.getFeatureById(node1); // 前一个节点
                let node1Id="";
                if(first_point){
                    node1Id=first_point.get("id");
                }

                let node2Id="";
                let node2=nodeProps.node2||"";
                let last_point=this.drawSource.getFeatureById(node2); // 后一个节点
                if(last_point){
                    node2Id=last_point.get("id");
                }
                // 保存数据
                temp=[id,node1Id,node2Id,first[0],first[1],last[0],last[1]];
                filejson.pipescoor.data.push(temp);

                // 保存属性信息
                
            break;
            case 0: // 节点类型0
            case 1: // 节点类型1
                let point=geom.getCoordinates();
                temp=[id,_node_type,_type,point[0],point[1]];
                filejson.nodescoor.data.push(temp);
                
                // 保存属性信息

            break;
            case 2:// 设备节点
                let point_d=geom.getCoordinates();
                // 获取绑定的线段
                let lines=item.get("lines");
                if(lines){
                    let lID=lines[0]||"";
                    let line=this.drawSource.getFeatureById(lID); // 后一个节点
                    let lineProp=line.getProperties();
                    let lineId=lineProp.id;
                    temp=[id,lineId,_type,point_d[0],point_d[1]];
                    filejson.devicescoor.data.push(temp);

                    // 保存属性信息

                }
            break;
        }
    }


    // 查找节点
    findNode(nodetype){
        for(let node of NodeTypes){
            let _node_type=node._type;
            let name=node.name;
            if(_node_type==nodetype||name==nodetype){
                return node;
            }
        }
        // 如果找不到合适的，则返回默认的节点
        return {
            name:"分支",
            _type:"branch", 
            _node_type:0, 
            img:"branch.png",
        };
    }

    // 转换属性数组为属性对象
    transformProperties(data,header){
        /**
         * 遍历属性部分，生成属性节点
         */
        let props={}; // 属性信息
        for(let p of data){
            let temp={};
            let idIndex=-1;
            // 获取属性的编号和名称
            for(let [i,v] of header.entries()){
                temp[v]=p[i];
                if(v=="id"){
                    idIndex=i;
                }
            }
            let id=p[idIndex];
            if(id>=0){
                props[id]=temp;
            }
        }
        return props
    }

    // 对字段进行转换
    transformDigital(result){
        // 对属性数据进行格式化，能转成整型的，就专程整形，转不成就转成浮点型，最后是字符串
        let temp=parseFloat(result);
        if(!isNaN(temp)){
            temp=parseInt(result);
        }
        if(!isNaN(temp)){
            result=temp;
        }
        return result;
    }
    // 获取默认值
    getDefault(type){
        return store.getters['simulation/getDefault'](type)
    }

}